import {
    staticHolidays,
    dynamicHolidays,
    staticStateHolidays,
    dynamicStateHolidays
} from './Holidays';

/*

const staticHolidays = ["01-01", "05-01", "10-03", "12-25", "12-26"];
const dynamicHolidays = [-2, 1, 39, 50];
const staticStateHolidays = {
    "Baden-Württemberg": ["11-01"],
    "Bayern": ["01-06", "08-08", "08-15", "11-01"],
    "Berlin": ["03-08"],
    "Brandenburg": ["10-31"],
    "Bremen": ["10-31"],
    "Hamburg": ["10-31"],
    "Hessen": [],
    "Mecklenburg-Vorpommern": ["03-08", "10-31"],
    "Niedersachsen": ["10-31"],
    "Nordrhein-Westfalen": ["11-01"],
    "Rheinland-Pfalz": ["11-01"],
    "Saarland": ["11-01"],
    "Sachsen": ["08-15", "10-31"],
    "Sachsen-Anhalt": ["01-06", "10-31"],
    "Schleswig-Holstein": ["10-31"],
    "Thüringen": ["09-20", "10-31"]
}
const dynamicStateHolidays = {
    "Baden-Württemberg": [60],
    "Bayern": [60, 9999],
    "Berlin": [],
    "Brandenburg": [49],
    "Bremen": [],
    "Hamburg": [],
    "Hessen": [49, 60],
    "Mecklenburg-Vorpommern": [],
    "Niedersachsen": [],
    "Nordrhein-Westfalen": [60],
    "Rheinland-Pfalz": [60],
    "Saarland": [60],
    "Sachsen": [60,9999],
    "Sachsen-Anhalt": [],
    "Schleswig-Holstein": [],
    "Thüringen": [60]
}

*/

const formatDateTime = (date = "2023-01-01", time = "00:00:00") => {
    return formatDate(date) + " " + formatTime(time);
}

const formatDate = (date = false) => {
    if (!date) return "";

    let dt
    if (typeof time == "object") {
        dt = date;
    }
    else {
        dt = new Date(date);
    }

    if (!dt) return "";

    let d = (dt.getDate() < 10) ? "0" + dt.getDate() : dt.getDate();
    let m = ((dt.getMonth() + 1) < 10) ? "0" + (dt.getMonth() + 1) : (dt.getMonth() + 1);
    let y = dt.getFullYear();
    return d + "." + m + "." + y;
}

const  formatTime = (time = "00:00:00") => {
    let t;
    if (typeof time == "object") {
        t = time;
    }
    else {
        t = new Date("1970-01-01 " + time);
    }

    let h = (t.getHours() < 10) ? "0" + t.getHours() : t.getHours();
    let m = (t.getMinutes() < 10) ? "0" + t.getMinutes() : t.getMinutes();
    return h + ":" + m;
}

const getDateFromString = (dateString = "01.01.2000", timeString = "00:00:00") => {
    const dateParts = dateString.split(".");
    const timeParts = timeString.split(":");
    if (timeParts.length == 2) {
        timeParts.push("00");
    }

    const dateObject = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0], timeParts[0], timeParts[1], timeParts[2]);

    return dateObject;
}

const getDateFromFullString = (dateTimeString = "01.01.2000 00:00:00") => {
    const dateTimeParts = dateTimeString.split(" ");
    const dateParts = dateTimeParts[0].split(".");
    const timeParts = dateTimeParts[1].split(":");
    if (timeParts.length == 2) {
        timeParts.push("00");
    }

    const dateObject = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0], timeParts[0], timeParts[1], timeParts[2]);

    return dateObject;
}

const getGermanDateFromString = (dateString = "2000-01-01") => {
    const d = dateString.split("-");

    return d[2] + "." + d[1] + "." + d[0];
}

const getEaster = (year) => {
    var f = Math.floor,
        // Golden Number - 1
        G = year % 19,
        C = f(year / 100),
        // related to Epact
        H = (C - f(C / 4) - f((8 * C + 13) / 25) + 19 * G + 15) % 30,
        // number of days from 21 March to the Paschal full moon
        I = H - f(H / 28) * (1 - f(29 / (H + 1)) * f((21 - G) / 11)),
        // weekday for the Paschal full moon
        J = (year + f(year / 4) + I + 2 - C + f(C / 4)) % 7,
        // number of days from 21 March to the Sunday on or before the Paschal full moon
        L = I - J,
        month = 3 + f((L + 40) / 44),
        day = L + 28 - 31 * f(month / 4);

    return [month, day];
}

const getHolidays = (year = false, state = false) => {
    if (year === false) {
        let d = new Date();
        year = d.getFullYear();
    }
    
    let easterDay = getEaster(year);
    let easterDate = new Date(year, easterDay[0] -1, easterDay[1]); //Month -1 damit richtiger Index verwendet wird [Januar = 0]

    let holidays = [];

    for (var i = 0; i < staticHolidays.length; i++) {
        holidays.push({ date: year + "-" + staticHolidays[i].date, name: staticHolidays[i].name })
    }

    
    for (var i = 0; i < dynamicHolidays.length; i++) {
        let day = new Date(easterDate.valueOf());
        day.setDate(easterDate.getDate() + dynamicHolidays[i].date);      
        let m = day.getMonth() + 1;
        let d = day.getDate();

        if (m < 10) {
            m = "0" + m;
        }
        if (d < 10) {
            d = "0" + d;
        }
        holidays.push({ date: year + "-" + m + "-" + d, name: dynamicHolidays[i].name });
    }

    if (state != false) {
        let stateStatic = staticStateHolidays[state];
        let stateDynamic = dynamicStateHolidays[state];

        if (stateStatic) {
            for (var i = 0; i < stateStatic.length; i++) {
                holidays.push({ date: year + "-" + stateStatic[i].date, name: stateStatic[i].name })
            }
        }
        
        if (stateDynamic) {
            for (var i = 0; i < stateDynamic.length; i++) {
                let day = new Date(easterDate.valueOf());
                if (stateDynamic[i].date == 9999) { //Buß und Bettag
                    let anchorDate = new Date(year, 10, 23);
                    
                    let i = anchorDate.getDay();
                    i -= 3;
                    if (i <= 0) {
                        i += 7;
                    }
 
                    day = anchorDate;

                    day.setDate(anchorDate.getDate() - i);
                } else {
                    day.setDate(easterDate.getDate() + stateDynamic[i].date);
                }

                let m = day.getMonth() +1;
                let d = day.getDate();
                if (m < 10) {
                    m = "0" + m;
                }
                if (d < 10) {
                    d = "0" + d;
                }
                holidays.push({ date: year + "-" + m + "-" + d, name: stateDynamic[i].name });
            }
        }
    }

    return holidays;
}

const getCurrencyFormatter = (currency = "EUR") => {
    let formatter = new Intl.NumberFormat('de-DE', {
        style: 'currency',
        currency: currency,
    });

    return formatter;
}


export default formatDateTime
export { formatDate, formatTime, getEaster, getHolidays, getDateFromString, getDateFromFullString, getGermanDateFromString, getCurrencyFormatter }